import React from 'react';
import ConvocationPageShell from '../../components/ConvocationPageShell';
import YomHameaStatic from './YomHameaStatic';

const YomHamea = () => (
  <ConvocationPageShell
    strapiApiId="convocation-yom-hamea"
    defaultTitle="Yom Hamea"
    StaticFallback={YomHameaStatic}
  />
);

export default YomHamea;
